import ESigningFormApi from './ESigningForm.api';
import ESigningFormPersonalNumber from './ESigningForm.personalNumber';

export default class ESigningFormReceivers {
    /**
     * @description Fetch receiver data from API and populate dropdown
     * @param {*} form
     * @param {string} endpoint
     * @returns {Promise<void>}
     */
    static async fetchReceiverDataAsync(form, endpoint) {
        const customerNumber = document.getElementById('customerNumberElementId')?.value;
        const params = customerNumber ? { customerNumber } : undefined;
        const response = await ESigningFormApi.fetchJson(endpoint, params);
        if (response && response.status === 200) {
            ESigningFormReceivers.setReceiverDropDown(form, response.body);
        }
    }

    /**
     * @description Populate the receiver dropdown
     * @param {*} form
     * @param {Array} result - Array of receiver objects from API
     * @returns void
     */
    static setReceiverDropDown(form, result) {
        if (!result) return;
        const dropdown = document.querySelector('.receiverDropdown .dropdown');
        if (!dropdown) return;
        for (const item of result) {
            const listItem = document.createElement('li');
            const roles = item.RoleProfileName || '';
            listItem.className = 'dropDownTrigger';
            listItem.dataset.email = item.Email || '';
            listItem.dataset.name = item.Name || '';
            listItem.dataset.personalnumber = item.PersonalNumber || '';
            listItem.dataset.mobilephonenumber = item.MobilePhoneNumber || '';
            listItem.textContent = item.Name ? `${roles} (${item.Name})` : '';
            listItem.addEventListener('click', (evt) => ESigningFormReceivers.selectReceiver(form, evt));
            dropdown.appendChild(listItem);
        }

        const receiverDropdown = document.querySelector('.receiverDropdown');
        const currentUserEmail = receiverDropdown?.dataset.currentUserEmail?.trim().toLowerCase();
        const currentUserReceiver = currentUserEmail
            ? [...dropdown.querySelectorAll('li.dropDownTrigger')]
                .find((item) => item.dataset.email?.trim().toLowerCase() === currentUserEmail)
            : null;

        const currentSignerName = document.getElementById('CurrentSignerName');
        const currentSignerEmail = document.getElementById('CurrentSignerEmail');
        const currentSignerPhone = document.getElementById('CurrentSignerPhoneNumber');
        const currentSignerPersonalNumber = document.getElementById('CurrentSignerPersonalNumber');
        const currentSignerEmailSummary = document.getElementById('CurrentSignerEmailSummary');
        if (currentSignerName) currentSignerName.value = currentUserReceiver?.dataset.name || receiverDropdown?.dataset.currentUserName || '';
        if (currentSignerEmail) currentSignerEmail.value = currentUserReceiver?.dataset.email || receiverDropdown?.dataset.currentUserEmail || '';
        if (currentSignerPhone) currentSignerPhone.value = currentUserReceiver?.dataset.mobilephonenumber || '';
        if (currentSignerPersonalNumber) {
            currentSignerPersonalNumber.value = ESigningFormPersonalNumber.normalizePersonalNumber(
                currentUserReceiver?.dataset.personalnumber || receiverDropdown?.dataset.currentUserPersonalNumber || ''
            );
        }
        if (currentSignerEmailSummary) currentSignerEmailSummary.textContent = currentSignerEmail?.value || '';

        if (currentSignerPersonalNumber?.value) {
            currentSignerPersonalNumber.dispatchEvent(new Event('change'));
        }
    }

    /**
     * @description Handle receiver selection from dropdown
     * @param {*} form
     * @param {Event} evt
     * @returns void
     */
    static selectReceiver(form, evt) {
        for (const item of document.querySelectorAll('li.dropDownTrigger')) {
            item.classList.remove('selected');
        }
        evt.target.classList.add('selected');
        const showcase = document.querySelector('.receiverDropdown .showcase a');
        if (showcase) showcase.innerHTML = evt.target.innerHTML;
        const dropdownEl = document.querySelector('.receiverDropdown .dropdown');
        if (dropdownEl) dropdownEl.style.display = 'none';
        for (const item of document.querySelectorAll('div.agreementElement')) {
            item.classList.remove('disabled');
        }

        const selectedReceiver = evt.target.dataset || {};
        const signerInput = document.getElementById('Signer');
        if (signerInput) signerInput.value = selectedReceiver.email || '';

        const receiverNameInput = document.getElementById('ReceiverName');
        if (receiverNameInput) receiverNameInput.value = selectedReceiver.name || '';

        const receiverEmailInput = document.getElementById('ReceiverEmail');
        if (receiverEmailInput) receiverEmailInput.value = selectedReceiver.email || '';

        const receiverPhoneInput = document.getElementById('ReceiverPhoneNumber');
        if (receiverPhoneInput) receiverPhoneInput.value = selectedReceiver.mobilephonenumber || '';

        const receiverPersonalInput = document.getElementById('ReceiverPersonalNumber');
        if (receiverPersonalInput) {
            ESigningFormPersonalNumber.setReceiverPersonalNumberFromDropdown(form, selectedReceiver.personalnumber || '');
        }

        ESigningFormPersonalNumber.formatReceiverPersonalNumber(form);

        // Setting .value directly doesn't fire 'input', so re-validate: clear errors that are now
        // resolved, but keep/show errors for fields the selected receiver still lacks data for
        ['ReceiverEmail', 'ReceiverPhoneNumber', 'ReceiverPersonalNumber'].forEach((id) => form.validateStep2InputField(id, true));
    }
}
